import { useMemo } from "react";

const libraryCategories = [
  { name: "lullaby", headingKey: "lullabies" },
  { name: "color_noise", headingKey: "lullaby.category.colorNoises" },
  { name: "household", headingKey: "lullaby.category.householdSounds" },
  { name: "nature", headingKey: "lullaby.category.natureSounds" },
  { name: "traveling", headingKey: "lullaby.category.travelingSound" }
];

function getFilteredLullabies(usersLullabies, lullabiesLibrary) {
  return lullabiesLibrary.filter((libraryLullaby) => {
    return !usersLullabies.some((lullaby) => {
      return lullaby.libraryIdentifier === libraryLullaby.identifier;
    });
  });
}
function getLullabiesByCategory(lullabiesLibrary) {
  return lullabiesLibrary.reduce((byCategory, lullaby) => {
    const { category } = lullaby;
    if (!byCategory[category]) byCategory[category] = {};
    byCategory[category][lullaby.objectId] = lullaby;
    return byCategory;
  }, {});
}

export default function useMemoizedCategories({
  lullabiesLibrary,
  usersLullabies
}) {
  return useMemo(() => {
    if (lullabiesLibrary.length === 0) return [];
    const filteredLullabies = getFilteredLullabies(
      Object.values(usersLullabies),
      lullabiesLibrary
    );
    const lullabiesByCategory = getLullabiesByCategory(filteredLullabies);
    const filteredCategories = libraryCategories.filter(
      ({ name }) => name in lullabiesByCategory
    );
    return filteredCategories.map((category) => ({
      ...category,
      lullabies: lullabiesByCategory[category.name]
    }));
  }, [lullabiesLibrary, usersLullabies]);
}
